<Nav />
<div class="section">
  <div class="container">
    {#if $uiState.activeModal}
      <svelte:component
        this={$uiState.activeModal.component}
        {...$uiState.activeModal.props}
      />
    {/if}
    <slot />
  </div>
</div>

<script lang="ts">
  import Nav from "./_components/Nav.svelte";

  import { uiState } from "../../lib/uiState";
</script>
